import {useEffect, useState} from "react";
import {useSearchParams} from "react-router-dom";
import styled from "styled-components";
import {agent} from "../../../api/agent";
import Loading from "../../Loading";

const Frame = styled.iframe`
    width: 100%;
    height: 100vh;
    border: none;
    display: block;
`;

export default function TestResultsView() {
    const [searchParams] = useSearchParams();
    const skeletonId = searchParams.get('skeleton');
    const [url, setUrl] = useState<string | null>(null);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (!skeletonId) {
            setError('No job specified.');
            return;
        }
        agent.requestAsset('tests.html', skeletonId).then((response) => {
            setUrl('https://api-ci.zenzon.net/download?token=' + response.token);
        }).catch(() => {
            setError('Unable to load test results.');
        });
    }, [skeletonId]);

    if (error) {
        return <p>{error}</p>;
    }

    if (!url) {
        return <Loading open={true}></Loading>;
    }

    return <Frame src={url} title={'Test Results'}></Frame>;
}
